var _defs, _g, _path, _path2, _g2, _g3, _g4, _path3, _g5, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "id1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.296875 0 L 27.703125 0 L 27.703125 29 L 2.296875 29 Z M 2.296875 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 8 L 16 8 L 16 15 L 7 15 Z M 7 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.652344 11.839844 L 7.898438 14.890625 L 15.050781 11.832031 L 15.050781 8.757812 Z M 7.652344 11.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAfCAYAAAD0ma06AAAABmJLR0QA/wD/AP+gvaeTAAAAN0lEQVRIie3NMQ0AIBAEwX2CELTg3wY6wAD1FZ8dAwOSJKm/AlYynMBuHRZw0uFNhiOZGRoafj2YPwKkiwMTWgAAAABJRU5ErkJggg==",
    id: "id5",
    height: 31,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#id1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAfCAYAAAD0ma06AAAABmJLR0QA/wD/AP+gvaeTAAAAN0lEQVRIie3NMQ0AIBAEwX2CELTg3wY6wAD1FZ8dAwOSJKm/AlYynMBuHRZw0uFNhiOZGRoafj2YPwKkiwMTWgAAAABJRU5ErkJggg==",
    height: 31,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "id7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 28,
    y: 0,
    height: 31
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "id8",
    patternUnits: "userSpaceOnUse",
    width: 28,
    patternTransform: "matrix(0.967742, 0, 0, -0.967742, 1.451612, 29.922582)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 28 31",
    height: 31,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id7)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#id6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.319999,
    width: 44.639999,
    fill: "#d1d3d4",
    height: 44.64,
    y: -6.9,
    fillOpacity: 1
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "id9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 5 L 23 5 L 23 12 L 15 12 Z M 15 5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.972656 5.457031 L 15.050781 8.757812 L 15.050781 11.832031 L 22.660156 8.578125 Z M 22.972656 5.457031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAfCAYAAAD0ma06AAAABmJLR0QA/wD/AP+gvaeTAAAANklEQVRIie3NMREAIBAEsX2GHkn4L9AEGmiu+NkYCEiSJOlbASsZTmC3Dgs46fAmw5HMDHuED3HXAm/YqrExAAAAAElFTkSuQmCC",
    id: "id11",
    height: 31,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "id12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#id1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAfCAYAAAD0ma06AAAABmJLR0QA/wD/AP+gvaeTAAAANklEQVRIie3NMREAIBAEsX2GHkn4L9AEGmiu+NkYCEiSJOlbASsZTmC3Dgs46fAmw5HMDHuED3HXAm/YqrExAAAAAElFTkSuQmCC",
    height: 31,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "id13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 28,
    y: 0,
    height: 31
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "id14",
    patternUnits: "userSpaceOnUse",
    width: 28,
    patternTransform: "matrix(0.967742, 0, 0, -0.967742, 1.451612, 29.922582)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 28 31",
    height: 31,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id13)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#id12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8.319999,
    width: 44.639999,
    fill: "#d1d3d4",
    height: 44.64,
    y: -6.9,
    fillOpacity: 1
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "id15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 11 L 23 11 L 23 24 L 7 24 Z M 7 11 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.664062 11.839844 L 7.910156 14.890625 L 18.882812 14.925781 L 18.640625 18.992188 L 15.027344 20.007812 L 11.554688 19.132812 L 11.347656 16.605469 L 8.121094 16.605469 L 8.539062 21.480469 L 15.0625 23.410156 L 21.546875 21.515625 L 22.390625 11.835938 L 7.664062 11.835938 Z M 7.664062 11.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1228.269877,
    gradientTransform: "matrix(5.535996, 0, 0, 5.535996, 6807.36071, 6364.612664)",
    y1: -1146.49402,
    x2: -1225.609702,
    gradientUnits: "userSpaceOnUse",
    y2: -1146.49402,
    id: "id17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.99884%, 90.59906%, 89.7995%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.137695%, 90.744019%, 89.956665%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.418457%, 91.036987%, 90.274048%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.699219%, 91.329956%, 90.592957%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.97998%, 91.624451%, 90.910339%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.262268%, 91.917419%, 91.229248%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.54303%, 92.211914%, 91.548157%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.823792%, 92.504883%, 91.867065%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.106079%, 92.799377%, 92.185974%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.386841%, 93.092346%, 92.504883%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.667603%, 93.386841%, 92.823792%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.94989%, 93.67981%, 93.1427%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.230652%, 93.974304%, 93.461609%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.511414%, 94.267273%, 93.780518%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.793701%, 94.561768%, 94.099426%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.074463%, 94.854736%, 94.416809%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.355225%, 95.149231%, 94.735718%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.637512%, 95.443726%, 95.054626%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.918274%, 95.736694%, 95.373535%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.199036%, 96.031189%, 95.692444%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.481323%, 96.324158%, 96.011353%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.762085%, 96.618652%, 96.330261%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.042847%, 96.911621%, 96.64917%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.325134%, 97.206116%, 96.968079%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.605896%, 97.499084%, 97.286987%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.886658%, 97.793579%, 97.605896%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.168945%, 98.086548%, 97.923279%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.449707%, 98.381042%, 98.242188%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.730469%, 98.674011%, 98.561096%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.012756%, 98.968506%, 98.880005%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.293518%, 99.261475%, 99.198914%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.57428%, 99.555969%, 99.517822%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.856567%, 99.848938%, 99.836731%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 5 L 23 5 L 23 9 L 6 9 Z M 6 5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.988281 5.457031 L 22.976562 5.457031 L 22.660156 8.578125 L 7.371094 8.578125 Z M 6.988281 5.457031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -1228.392243,
    gradientTransform: "matrix(5.535996, 0, 0, 5.535996, 6807.36071, 6364.612664)",
    y1: -1148.41003,
    x2: -1225.504139,
    gradientUnits: "userSpaceOnUse",
    y2: -1148.41003,
    id: "id20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.99884%, 90.59906%, 89.7995%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.139221%, 90.745544%, 89.958191%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.419983%, 91.038513%, 90.275574%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.700745%, 91.333008%, 90.594482%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(91.983032%, 91.625977%, 90.913391%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.263794%, 91.920471%, 91.2323%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.544556%, 92.21344%, 91.551208%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.826843%, 92.507935%, 91.870117%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.107605%, 92.800903%, 92.189026%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.388367%, 93.095398%, 92.506409%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.670654%, 93.388367%, 92.825317%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.951416%, 93.682861%, 93.144226%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.232178%, 93.97583%, 93.463135%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.514465%, 94.270325%, 93.782043%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.795227%, 94.563293%, 94.100952%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.075989%, 94.857788%, 94.419861%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.358276%, 95.150757%, 94.73877%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.639038%, 95.445251%, 95.057678%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.9198%, 95.73822%, 95.376587%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.202087%, 96.032715%, 95.695496%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.482849%, 96.325684%, 96.012878%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.763611%, 96.620178%, 96.331787%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.045898%, 96.914673%, 96.650696%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.32666%, 97.207642%, 96.969604%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.607422%, 97.502136%, 97.288513%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.889709%, 97.795105%, 97.607422%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.170471%, 98.0896%, 97.926331%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.451233%, 98.382568%, 98.245239%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.733521%, 98.677063%, 98.564148%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.014282%, 98.970032%, 98.883057%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.295044%, 99.264526%, 99.201965%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.577332%, 99.557495%, 99.519348%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.858093%, 99.85199%, 99.838257%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2062af",
    d: "M 25.394531 26.042969 L 15.058594 28.828125 L 4.722656 26.042969 L 2.335938 0.203125 L 27.78125 0.203125 Z M 25.394531 26.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3c9cd7",
    d: "M 15.058594 2.296875 L 15.058594 26.609375 L 15.082031 26.613281 L 23.449219 24.363281 L 25.378906 2.296875 Z M 15.058594 2.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 15.050781 8.757812 L 7.652344 11.839844 L 7.898438 14.890625 L 15.050781 11.832031 L 22.660156 8.578125 L 22.972656 5.460938 Z M 15.050781 8.757812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id8)",
    d: "M 7.652344 8.757812 L 15.050781 8.757812 L 15.050781 14.890625 L 7.652344 14.890625 Z M 7.652344 8.757812 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id14)",
    d: "M 15.050781 5.457031 L 22.976562 5.457031 L 22.976562 11.832031 L 15.050781 11.832031 Z M 15.050781 5.457031 ",
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id15)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id17)",
    d: "M 7.664062 11.835938 L 7.664062 23.410156 L 22.390625 23.410156 L 22.390625 11.835938 Z M 7.664062 11.835938 ",
    fillRule: "nonzero"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 15.050781 11.839844 L 7.652344 11.839844 L 7.898438 14.890625 L 15.050781 14.914062 Z M 15.050781 20 L 15.015625 20.007812 L 11.546875 19.132812 L 11.335938 16.605469 L 8.109375 16.605469 L 8.527344 21.480469 L 15.050781 23.410156 Z M 15.050781 20 ",
    fillOpacity: 0.0471,
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id20)",
    d: "M 6.988281 5.457031 L 6.988281 8.578125 L 22.976562 8.578125 L 22.976562 5.457031 Z M 6.988281 5.457031 ",
    fillRule: "nonzero"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 15.050781 5.457031 L 6.988281 5.457031 L 7.371094 8.578125 L 15.050781 8.578125 Z M 15.050781 5.457031 ",
    fillOpacity: 0.0471,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.7b004113a32d366e8d284b9803178b77.svg";
export { ForwardRef as ReactComponent };